export default "__VITE_ASSET__e3b1d6b9__"